import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ResourceUser } from '../../domain/model/resource-user';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { ConfirmDialogService } from '../../service/common/dialog/confirm-dialog.service';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { ResourceUserService } from '../../service/settings/resource-user.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'redispatch-settings-resource-user-detail',
    templateUrl: './settings-resource-user-detail.component.html',
    styleUrls: [
        './settings-resource-user-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsResourceUserDetailComponent implements OnInit {

    public createNew: boolean = false;
    public currentUsername?: string = null;
    public userForm: UntypedFormGroup;
    public passwordHide = true;

    private userService = inject(ResourceUserService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private confirmDialogService = inject(ConfirmDialogService);
    public westnetzSidenavService = inject(WestnetzSidenavService);
    private formBuilder = inject(UntypedFormBuilder);
    private changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {

        this.userForm = this.formBuilder.group({
            username: [
                '',
                [
                    Validators.required,
                ],
            ],
            password: [
                '',
                [
                    Validators.required,
                ],
            ],
            enabled: [
                true,
                [
                    Validators.required,
                ],
            ],
            allowRead: [
                false,
                [
                    Validators.required,
                ],
            ],
            allowWrite: [
                false,
                [
                    Validators.required,
                ],
            ],
        });
    }

    ngOnInit() {
        const userName = this.activatedRoute.snapshot.queryParams['username'];
        this.createNew = userName == null || userName === '';
        if (!this.createNew) {
            this.userForm.controls.username.disable();
            this.userForm.controls.password.clearValidators();
            this.userService.getUserByUsername(userName)
                .pipe(take(1))
                .subscribe((user: ResourceUser) => {
                    this.userForm.patchValue(user);
                    this.currentUsername = userName;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    public get f(): { [key: string]: AbstractControl } {
        return this.userForm.controls;
    }

    saveUser() {
        if (this.userForm.invalid) {
            this.userForm.setErrors({ 'invalidForm': true });
            return;
        }

        if (this.createNew) {
            this.userService.saveUser(this.userForm.getRawValue()).subscribe({
                next: () => {
                    this.westnetzSidenavService.closeRightnav();
                    this.notificationService.success('Der Benutzer wurde erfolgreich angelegt');
                },
                error: () => {
                    this.notificationService.failure('Der Benutzer konnte nicht gespeichert werden');
                },
            });
        } else {
            this.userService.updateUser(this.currentUsername, this.userForm.getRawValue()).subscribe({
                next: () => {
                    this.westnetzSidenavService.closeRightnav();
                    this.notificationService.success('Der Benutzer wurde erfolgreich geupdated');
                },
                error: () => {
                    this.notificationService.failure('Der Benutzer konnte nicht geupdated werden');
                },
            });
        }
    }

    async deleteUser() {
        if (!this.createNew && await this.confirmDialogService.confirm(
            'Sind Sie sicher, dass Sie den Benutzer enfernen möchten?',
            'Benutzer entfernen!',
            'warn',
            'Entfernen',
        )) {
            this.userService.deleteUser(this.currentUsername).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Benutzer wurde entfernt');
            });
        }
    }
}
